import { useMatch } from 'react-router-dom';

import {
  PROFILE_PAGE,
  CREATE_RESUME_PAGE,
  CREATE_RESUME_PAGE_URL,
} from 'src/components/Router';
import type { Page } from 'src/types';

export const usePage = (): Page => {
  const createResumePageMatch = useMatch(CREATE_RESUME_PAGE_URL);

  // Note: Order important - most specific routes first!
  if (createResumePageMatch) {
    return CREATE_RESUME_PAGE;
  }

  return PROFILE_PAGE;
};
